import { ButtonProps } from "@mui/material";
import FlowConfirmButton from "./FlowConfirmButton";
import { useStylesCss } from "./AppButtons.styles";

const TextConfirmButton: React.FC<ButtonProps> = (props: ButtonProps) => {
  const classes = useStylesCss();
  const myClasses = { ...props.sx, ...classes.general };
  const myProps = {
    sx: myClasses,
    ...props,
  };
  return (
    <FlowConfirmButton {...myProps} disableElevation={true} size="small">
      {props.children}
    </FlowConfirmButton>
  );
};
export default TextConfirmButton;
